/* Slow Cow — Glacier interactions. No dependencies. Safe to run more than once (theme editor reloads sections). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var activeModal = null;
  function modalAccess(root, on) {
    if (!on) {
      if (root.scInert) root.scInert.forEach(function (entry) { entry[0].inert = entry[1]; });
      root.scInert = null;
      if (activeModal === root) activeModal = null;
      if (root.scReturnFocus && root.scReturnFocus.isConnected) root.scReturnFocus.focus({ preventScroll: true });
      return;
    }
    if (activeModal === root) return;
    root.scReturnFocus = document.activeElement;
    root.scInert = [];
    var branch = root;
    while (branch.parentElement && branch !== document.body) {
      Array.prototype.forEach.call(branch.parentElement.children, function (sibling) {
        if (sibling !== branch && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
          root.scInert.push([sibling, sibling.inert]); sibling.inert = true;
        }
      });
      branch = branch.parentElement;
    }
    activeModal = root;
  }
  function modalHeading(root) {
    var step = root.querySelector('[data-step]:not([hidden])');
    var title = step && step.querySelector('h2[id]');
    var dialog = root.querySelector('[role=dialog]');
    if (dialog && title) dialog.setAttribute('aria-labelledby', title.id);
  }
  document.addEventListener('keydown', function (event) {
    if (!activeModal || event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(activeModal.querySelectorAll('button, a[href], input, select, textarea, [tabindex]'), function (el) {
      return !el.disabled && el.tabIndex >= 0 && !el.closest('[hidden]') && el.getClientRects().length;
    });
    if (!items.length) { event.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !activeModal.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !activeModal.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });

  /* ---- Tabs (three cans, ingredient lists) ---- */
  function activate(root, tab, focus) {
    var tabs = root.querySelectorAll('[data-sc-tab]');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    var m = (tab.className.match(/sc-a-([a-z]+)/) || [])[1];
    if (m) root.setAttribute('data-sc-accent', m);
    if (focus) tab.focus();
    if (tab.scrollIntoView && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
      tab.parentElement.scrollTo({ left: tab.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
    }
  }
  function initTabs(scope) {
    scope.querySelectorAll('[data-sc-tabs]').forEach(function (root) {
      if (root.scInit) return; root.scInit = true;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sc-tab]'));
      if (!tabs.length) return;
      // deep link: /#focus or ?can=focus opens that can
      var want = (new URLSearchParams(location.search).get('can') || '').toLowerCase();
      var first = tabs.filter(function (t) { return want && t.textContent.toLowerCase().indexOf(want) > -1; })[0] || tabs[0];
      activate(root, first, false);
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(root, tab, false); });
        tab.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault(); activate(root, tabs[(n + tabs.length) % tabs.length], true);
        });
      });
    });
  }

  /* ---- Slider (reviews) ---- */
  function initSliders(scope) {
    scope.querySelectorAll('[data-sc-slider]').forEach(function (slider) {
      if (slider.scInit) return; slider.scInit = true;
      var track = slider.querySelector('[data-sc-track]');
      var sec = slider.closest('.sc');
      var prev = sec.querySelector('[data-sc-prev]'), next = sec.querySelector('[data-sc-next]');
      if (!track || !prev || !next) return;
      function step(dir) {
        var card = track.children[0]; if (!card) return;
        track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 20), behavior: reduce ? 'auto' : 'smooth' });
      }
      function sync() {
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  /* ---- Ingredient filter ---- */
  function initFilters(scope) {
    scope.querySelectorAll('[data-sc-filter]').forEach(function (root) {
      if (root.scInit) return; root.scInit = true;
      var btns = root.querySelectorAll('[data-sc-filter-btn]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-sc-filter-btn');
          btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          root.querySelectorAll('[data-sc-in]').forEach(function (li) {
            li.hidden = key !== 'all' && (' ' + li.getAttribute('data-sc-in') + ' ').indexOf(' ' + key + ' ') === -1;
          });
        });
      });
    });
  }

  /* ---- Dialogs (nutrition labels). Moved to <body> so no parent transform can trap them. ---- */
  function initDialogs(scope) {
    scope.querySelectorAll('[data-sc-dialog-open]').forEach(function (btn) {
      if (btn.scInit) return; btn.scInit = true;
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-sc-dialog-open'));
        if (!dlg) return;
        if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    document.querySelectorAll('dialog.sc-dialog').forEach(function (dlg) {
      if (dlg.scInit) return; dlg.scInit = true;
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-sc-dialog-close]')) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
      });
    });
  }

  /* ---- Announcement rotation ---- */
  function initRotate(scope) {
    scope.querySelectorAll('[data-sc-rotate]').forEach(function (bar) {
      if (bar.scInit) return; bar.scInit = true;
      var msgs = bar.querySelectorAll('.sc-announce__msg'); if (msgs.length < 2) return;
      var i = 0, secs = parseInt(bar.getAttribute('data-sc-rotate'), 10) || 5;
      bar.scTimer = setInterval(function () {
        if (bar.scPaused) return;
        msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
      }, secs * 1000);
      bar.addEventListener('mouseenter', function () { bar.scPaused = true; });
      bar.addEventListener('mouseleave', function () { bar.scPaused = false; });
    });
  }

  /* ---- Stat count-up: the one scripted motion on the page ---- */
  function initCounts(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return; io.unobserve(en.target);
        var el = en.target, end = parseFloat(el.getAttribute('data-sc-count')); if (isNaN(end)) return;
        var t0 = null, dur = 1200;
        function tick(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    }, { threshold: .4 });
    scope.querySelectorAll('[data-sc-count]').forEach(function (el) { if (!el.scInit) { el.scInit = true; io.observe(el); } });
  }


  /* ---- Product buy box: gallery, variant sync (works with bundle apps like Kaching), sticky bar ---- */
  function initPdp(scope) {
    scope.querySelectorAll('[data-sc-pdp]').forEach(function (root) {
      if (root.scInit) return; root.scInit = true;
      var form = document.getElementById(root.getAttribute('data-form'));
      var idInput = form && form.querySelector('[name=id]');
      var gallery = root.querySelector('[data-sc-gallery]');
      var thumbs = root.querySelectorAll('.sc-pdp__thumb');
      var now = root.querySelector('[data-sc-gal-now]');
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-sc-variants]').textContent); } catch (e) {}

      function slides() { return gallery ? gallery.querySelectorAll('.sc-pdp__slide') : []; }
      function goTo(i) { var s = slides(); if (!s.length) return; i = Math.max(0, Math.min(s.length - 1, i)); gallery.scrollTo({ left: i * gallery.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      function current() { return gallery ? Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth)) : 0; }
      function showMedia(id, title) { var s = slides(), wanted = String(title || '').toLowerCase(); for (var i = 0; i < s.length; i++) { var match = s[i].getAttribute('data-variant-match'); if ((id && s[i].getAttribute('data-media-id') === String(id)) || (match && wanted.indexOf(match) > -1)) { goTo(i); break; } } }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      root.querySelectorAll('[data-sc-gal-nav]').forEach(function (b) { b.addEventListener('click', function () { goTo(current() + parseInt(b.getAttribute('data-sc-gal-nav'), 10)); }); });
      if (gallery) {
        var tick;
        gallery.addEventListener('scroll', function () {
          clearTimeout(tick); tick = setTimeout(function () {
            var i = current(); if (now) now.textContent = i + 1; root.querySelectorAll('[data-sc-gal-nav]').forEach(function (button) { button.disabled = button.getAttribute('data-sc-gal-nav') === '-1' ? i === 0 : i >= slides().length - 1; });
            thumbs.forEach(function (t, n) { var on = n === i; t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); if (on && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.parentElement.scrollTo({ left: t.offsetLeft - 60, behavior: reduce ? 'auto' : 'smooth' }); });
          }, 60);
        }, { passive: true });
        gallery.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Home' || e.key === 'End') { e.preventDefault(); goTo(e.key === 'Home' ? 0 : e.key === 'End' ? slides().length - 1 : current() + (e.key === 'ArrowRight' ? 1 : -1)); } });
      }

      var mainBtn = root.querySelector('.sc-buy .sc-atc');
      var lastId = null;
      var app = root.querySelector('.sc-buy');
      function hasApp() { var panel = root.querySelector('.sc-pdp__app, kaching-bundle, .kaching-bundles'); return !!(panel && (panel.querySelector('input,select,button,[role=radio],[role=combobox]') || panel.textContent.trim())); }
      function setText(el, value) { if (el && el.textContent !== value) el.textContent = value; }
      function syncSticky() {
        var stickyRoot = root.querySelector('[data-sc-sticky]');
        if (!stickyRoot || !mainBtn) return;
        var button = stickyRoot.querySelector('[data-sc-sticky-btn]');
        if (button) { button.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true' || mainBtn.classList.contains('loading'); button.setAttribute('aria-busy', mainBtn.classList.contains('loading') ? 'true' : 'false'); }
        var price = mainBtn.querySelector('[data-sc-price]');
        var amounts = mainBtn.textContent.match(/(?:[$€£]\s*\d[\d\s.,]*|\d[\d\s.,]*\s*[$€£])(?:\s*[A-Z]{3})?/g);
        var total = price ? price.textContent.trim() : amounts && amounts[amounts.length - 1].trim();
        if (hasApp()) {
          var selected = root.querySelector('.kaching-bundles__bar--selected');
          var title = selected && selected.querySelector('.kaching-bundles__bar-title');
          var flavours = selected ? Array.prototype.map.call(selected.querySelectorAll('[role=combobox]'), function (el) { return el.textContent.trim(); }).filter(Boolean) : [];
          var summary = title ? title.textContent.trim() + (flavours.length ? ' · ' + flavours.join(' + ') : '') : root.getAttribute('data-sc-order-label');
          setText(stickyRoot.querySelector('[data-sc-variant-name]'), summary);
          setText(stickyRoot.querySelector('[data-sc-price]'), total || root.getAttribute('data-sc-review-label'));
        } else if (total) setText(stickyRoot.querySelector('[data-sc-price]'), total);
        var label = button && button.querySelector('[data-sc-atc-label]');
        if (label) {
          if (!button.scLabel) button.scLabel = button.getAttribute('data-label') || label.textContent;
          setText(label, mainBtn.disabled && !mainBtn.classList.contains('loading') ? mainBtn.getAttribute('data-soldout') : button.scLabel);
        }
      }
      function apply(v, user) {
        if (!hasApp()) root.querySelectorAll('[data-sc-price]').forEach(function (el) { setText(el, v.price); });
        root.querySelectorAll('[data-sc-variant-name]').forEach(function (el) { el.textContent = variants.length > 1 ? v.title : ''; });
        var img = root.querySelector('[data-sc-sticky-img]');
        if (img && v.img && !img.hasAttribute('data-fixed')) { img.src = v.img; img.hidden = false; }
        if (!hasApp()) root.querySelectorAll('.sc-atc').forEach(function (btn) {
          var lab = btn.querySelector('[data-sc-atc-label]'); if (!lab) return;
          if (!lab.getAttribute('data-l')) lab.setAttribute('data-l', btn.getAttribute('data-label') || lab.textContent);
          if (btn === mainBtn) { btn.disabled = !v.available; }
          else btn.disabled = !v.available;
          lab.textContent = v.available ? lab.getAttribute('data-l') : (mainBtn ? mainBtn.getAttribute('data-soldout') : lab.textContent);
        });
        if (user) { showMedia(v.media, v.title); try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {} }
      }
      // follow the variant wherever it is changed: our cards, or an app (Kaching) writing into the form
      function sync(user) {
        if (!idInput) return; var id = String(idInput.value); if (id === lastId) return; var first = lastId === null; lastId = id;
        for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) { apply(variants[i], user && !first); break; }
      }
      root.querySelectorAll('.sc-pick input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () { if (!r.checked || !idInput) return; idInput.value = r.value; idInput.disabled = r.getAttribute('data-available') !== 'true'; idInput.dispatchEvent(new Event('change', { bubbles: true })); sync(true); });
      });
      sync(false);
      var requestedId = new URLSearchParams(location.search).get('variant');
      var requested = variants.find(function (variant) { return String(variant.id) === requestedId; });
      if (requested) showMedia(requested.media, requested.title);
      syncSticky();
      root.querySelectorAll('[data-sc-gal-nav="-1"]').forEach(function (button) { button.disabled = true; });
      ['change', 'click', 'input'].forEach(function (ev) { root.addEventListener(ev, function () { setTimeout(function () { sync(true); syncSticky(); }, 60); }); });
      var poll = setInterval(function () { if (!root.isConnected) { clearInterval(poll); return; } if (!document.hidden) { sync(true); syncSticky(); } }, 1500);
      var purchaseObserver = new MutationObserver(syncSticky);
      if (mainBtn) purchaseObserver.observe(mainBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });
      if (app) purchaseObserver.observe(app, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
      root.scCleanup = function () { clearInterval(poll); purchaseObserver.disconnect(); };


      root.querySelectorAll('[data-sc-qty]').forEach(function (box) {
        var input = box.querySelector('input');
        box.addEventListener('click', function (e) {
          var b = e.target.closest('button[data-d]'); if (!b) return;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-d'), 10));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // sticky bar: pressing it presses the real button, so bundle apps that hook that button keep working
      var sticky = root.querySelector('[data-sc-sticky]'), sBtn = root.querySelector('[data-sc-sticky-btn]');
      if (sBtn) sBtn.addEventListener('click', function () {
        var target = mainBtn && mainBtn.offsetParent !== null ? mainBtn : (form && (form.querySelector('[type=submit]:not([disabled])') || form.querySelector('button')));
        if (target) target.click(); else if (form && form.requestSubmit) form.requestSubmit();
      });
      var watch = mainBtn || form, nearFoot = false, pastBtn = false;
      function place() { sticky.hidden = !pastBtn || nearFoot; }
      if (sticky && watch && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (en) { pastBtn = !(en.isIntersecting || en.boundingClientRect.top > 0); place(); }); }, { threshold: 0 }).observe(watch);
        var foot = document.querySelector('.sc-footer') || document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
        function checkFoot() {
          var doc = document.documentElement, bottomGap = doc.scrollHeight - (window.scrollY + window.innerHeight);
          var ft = foot ? foot.getBoundingClientRect().top : Infinity;
          nearFoot = ft < window.innerHeight || bottomGap < 240; place();
        }
        var footRaf = 0; function queueFoot() { if (!footRaf) footRaf = requestAnimationFrame(function () { footRaf = 0; checkFoot(); }); }
        window.addEventListener('scroll', queueFoot, { passive: true }); window.addEventListener('resize', queueFoot); checkFoot();
      }
    });
  }


  /* ---- v6: scroll reveal + mascot pop ---- */
  var RV = '.sc .sc-head, .sc-world, .sc-ww__row, .sc-explain__item, .sc-card, .sc-benefit, .sc-stat, .sc-qa, .sc-gl__item, .sc-never__list li, .sc-dive__panel, .sc-dive__img, .sc-compare__table, .sc-label__panel, .sc-moments__panel, .sc-mascot__copy';
  var rvObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rvObs.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function initReveal(scope) {
    if (!rvObs || reduce) return;
    document.documentElement.classList.add('sc-js');
    scope.querySelectorAll(RV).forEach(function (el) {
      if (el.scRv || el.closest('.sc-hero') || el.closest('.sc-pdp')) return;
      el.scRv = true;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('is-in'); return; }
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--d', Math.min(sib, 4) * 0.08 + 's');
      el.classList.add('sc-rv'); rvObs.observe(el);
    });
    scope.querySelectorAll('[data-sc-mascot]').forEach(function (m) {
      if (m.scRv) return; m.scRv = true;
      if (!m.classList.contains('sc-mascot__art--peek')) return;
      new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { m.classList.add('is-in'); o.disconnect(); } }); }, { threshold: 0.2 }).observe(m);
    });
  }


  /* ---- v7: Switch on ---- */
  function initSwitch(scope) {
    scope.querySelectorAll('[data-sc-switch]').forEach(function (root) {
      if (root.scInit) return; root.scInit = true;
      var btn = root.querySelector('[data-sc-toggle]');
      if (!btn) {
        if (reduce || !('IntersectionObserver' in window)) { root.classList.add('is-on'); return; }
        new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { o.disconnect(); root.classList.add('is-on'); } }); }, { threshold: 0.3 }).observe(root);
        return;
      }
      var touched = false;
      function set(on) { btn.setAttribute('aria-checked', on ? 'true' : 'false'); root.classList.toggle('is-on', on); }
      btn.addEventListener('click', function () { touched = true; set(btn.getAttribute('aria-checked') !== 'true'); });
      var auto = root.getAttribute('data-auto') !== 'false';
      if (auto && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { o.disconnect(); setTimeout(function () { if (!touched) set(true); }, reduce ? 0 : 700); } }); }, { threshold: 0.55 }).observe(root);
      }
    });
  }


  /* ---- v8: photo wall entrance ---- */
  function initUgc(scope) {
    scope.querySelectorAll('[data-sc-ugc]').forEach(function (st) {
      if (st.scInit) return; st.scInit = true;
      if (reduce || !('IntersectionObserver' in window)) { st.classList.add('is-in'); return; }
      document.documentElement.classList.add('sc-js');
      var cards = st.querySelectorAll('.sc-ugc__card'), live = false, raf = 0;
      function frame() {
        var mid = window.innerWidth / 2, reach = Math.max(260, window.innerWidth * 0.6);
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect(), d = Math.min(1, Math.abs(r.left + r.width / 2 - mid) / reach), e = 1 - d * d;
          cards[i].style.setProperty('--s', (0.86 + 0.14 * e).toFixed(3));
          cards[i].style.setProperty('--o', (0.55 + 0.45 * e).toFixed(3));
        }
        if (live) raf = requestAnimationFrame(frame);
        if (document.documentElement.classList.contains('sc-overlay')) { cancelAnimationFrame(raf); raf = requestAnimationFrame(function w() { if (!live) return; if (document.documentElement.classList.contains('sc-overlay')) { raf = requestAnimationFrame(w); } else frame(); }); }
      }
      new IntersectionObserver(function (es) { es.forEach(function (e) {
        if (e.isIntersecting) { st.classList.add('is-in'); if (!live) { live = true; raf = requestAnimationFrame(frame); } }
        else { live = false; cancelAnimationFrame(raf); }
      }); }, { threshold: 0.05 }).observe(st);
    });
  }


  /* ---- v11: win popup (match 3 cards) ---- */
  function initPop(scope) {
    scope.querySelectorAll('[data-sc-pop]').forEach(function (pop) {
      if (pop.scInit) return; pop.scInit = true;
      var KEY = 'sc-pop-seen', days = +pop.getAttribute('data-days') || 14, test = pop.getAttribute('data-test') === '1';
      var done = !!pop.querySelector('[data-sc-pop-done]');
      function seen() { try { var t = +localStorage.getItem(KEY); return t && (Date.now() - t) < days * 864e5; } catch (e) { return false; } }
      function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
      function burst() {
        if (reduce) return;
        var box = pop.querySelector('.sc-pop__box'); if (!box) return;
        var cf = document.createElement('div'); cf.className = 'sc-pop__confetti';
        cf.style.setProperty('--fall', (box.offsetHeight + 40) + 'px');
        var cols = ['#2A217D', '#FFD766', '#FF8FB5', '#7ADCFF', '#2F58D6', '#F2B233'];
        for (var i = 0; i < 70; i++) {
          var b = document.createElement('i');
          b.style.left = (Math.random() * 100) + '%';
          b.style.background = cols[i % cols.length];
          b.style.animationDelay = (Math.random() * .5) + 's';
          b.style.animationDuration = (1.6 + Math.random() * 1.1) + 's';
          b.style.setProperty('--spin', (Math.random() > .5 ? 1 : -1) * (360 + Math.random() * 540) + 'deg');
          b.style.setProperty('--drift', (Math.random() * 80 - 40) + 'px');
          cf.appendChild(b);
        }
        box.appendChild(cf); setTimeout(function () { cf.remove(); }, 3400);
      }
      function step(n) { pop.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== n; }); modalHeading(pop); }
      var opened = false, lastFocus = null;
      function open() {
        if (opened) return; if (document.documentElement.classList.contains('sc-overlay')) { setTimeout(open, 4000); return; } opened = true; mark(); lastFocus = document.activeElement;
        pop.hidden = false; modalHeading(pop); modalAccess(pop, true); document.documentElement.classList.add('sc-pop-lock');
        requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
        var f = pop.querySelector('.sc-pop__x'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300);
      }
      function close() {
        pop.classList.remove('is-open'); modalAccess(pop, false); document.documentElement.classList.remove('sc-pop-lock');
        setTimeout(function () { pop.hidden = true; }, 450); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      pop.addEventListener('click', function (e) { if (e.target.closest('[data-sc-pop-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
      // the customer form posts back to the page: show the "done" step
      if (done || /[?&]customer_posted=true/.test(location.search) && location.hash.indexOf('ScPopForm') > -1) { step('done'); open(); setTimeout(burst, 550); return; }
      if (pop.querySelector('[data-sc-pop-error]')) { step('win'); open(); setTimeout(function () { var input = pop.querySelector('input[type=email]'); if (input) input.focus(); }, 350); return; }
      var cards = pop.querySelectorAll('.sc-card3'), grid = pop.querySelector('[data-sc-cards]'), flips = 0;
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.classList.contains('is-flipped') || flips >= 3) return;
          c.classList.add('is-flipped'); flips++;
          if (flips === 3) {
            grid.classList.add('is-won');
            burst();
            setTimeout(function () { step('win'); var em = pop.querySelector('input[type=email]'); if (em) em.focus({ preventScroll: true }); }, 1300);
          }
        });
      });
      var form = pop.querySelector('form'); if (form) { var a = form.getAttribute('action') || ''; form.setAttribute('action', a + (a.indexOf('#') > -1 ? '' : '#ScPopForm')); }
      if (test) { open(); return; }
      if (seen() || /\/(cart|checkout|account)/.test(location.pathname)) return;
      var ms = (+pop.getAttribute('data-delay') || 15) * 1000, pct = (+pop.getAttribute('data-scroll') || 40) / 100, mode = pop.getAttribute('data-trigger') || 'both';
      var timer = mode === 'scroll' ? 0 : setTimeout(open, ms);
      if (mode === 'time') return;
      var popRaf = 0; function onScroll() { if (popRaf) return; popRaf = requestAnimationFrame(function () { popRaf = 0; var h = document.documentElement.scrollHeight - innerHeight; if (h > 0 && scrollY / h >= pct) { clearTimeout(timer); window.removeEventListener('scroll', onScroll); setTimeout(open, 400); } }); }
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  }


  /* ---- v12: drawers play nice (menu fills the screen, menu and cart never open together, motion pauses) ---- */
  (function () {
    var root = document.documentElement;
    function overlayOn() {
      var menu = document.querySelector('#Details-menu-drawer-container[open]');
      var cart = document.querySelector('cart-drawer.active');
      var pop = document.querySelector('.sc-pop.is-open');
      root.classList.toggle('sc-overlay', !!(menu || cart || pop));
    }
    function setTop() {
      var h = document.querySelector('.section-header, sticky-header, .header-wrapper');
      if (h) root.style.setProperty('--sc-drawer-top', Math.max(0, h.getBoundingClientRect().bottom) + 'px');
    }
    function closeMenu() {
      var d = document.querySelector('#Details-menu-drawer-container[open]'); if (!d) return;
      var hd = d.closest('header-drawer'); var s = d.querySelector('summary');
      if (hd && hd.closeMenuDrawer) hd.closeMenuDrawer(null, s); else d.removeAttribute('open');
      if (s) s.setAttribute('aria-expanded', 'false');   // removes Dawn's dark backdrop behind the menu
      var hdr = document.querySelector('.header-wrapper, .section-header'); if (hdr) hdr.classList.remove('menu-open');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('#Details-menu-drawer-container > summary')) { setTop(); var cd = document.querySelector('cart-drawer.active'); if (cd && cd.close) cd.close(); }
      if (e.target.closest('#cart-icon-bubble, .header__icon--cart')) closeMenu();
      setTimeout(overlayOn, 60); setTimeout(overlayOn, 500);
    }, true);
    window.addEventListener('resize', setTop, { passive: true });
    var mo = new MutationObserver(overlayOn);
    document.addEventListener('DOMContentLoaded', function () {
      var cd = document.querySelector('cart-drawer'); if (cd) mo.observe(cd, { attributes: true, attributeFilter: ['class'] });
      var md = document.querySelector('#Details-menu-drawer-container'); if (md) mo.observe(md, { attributes: true, attributeFilter: ['open', 'class'] });
      document.querySelectorAll('.sc-pop').forEach(function (pp) { mo.observe(pp, { attributes: true, attributeFilter: ['class', 'hidden'] }); }); overlayOn();
    });
  })();


  /* ---- v14: "Get notified" modal for coming-soon cans ---- */
  (function () {
    function modal() { return document.querySelector('[data-sc-notify]'); }
    function step(m, n) { m.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== n; }); modalHeading(m); }
    function open(m, name) {
      clearTimeout(m.scCloseTimer);
      if (name) { var nm = m.querySelector('[data-sc-nname]'); if (nm) nm.textContent = name;
        var t = m.querySelector('[data-sc-ntags]'); if (t) t.value = 'newsletter,waitlist,waitlist-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-'); }
      m.hidden = false; modalHeading(m); modalAccess(m, true); document.documentElement.classList.add('sc-pop-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-open'); }); });
      setTimeout(function () { var e = m.querySelector('input[type=email]'); if (e && !m.querySelector('[data-step=form]').hidden) e.focus({ preventScroll: true }); }, 350);
    }
    function close(m) { m.classList.remove('is-open'); modalAccess(m, false); document.documentElement.classList.remove('sc-pop-lock'); m.scCloseTimer = setTimeout(function () { m.hidden = true; }, 450); }
    document.addEventListener('click', function (e) {
      var m = modal(); if (!m) return;
      var a = e.target.closest('[data-notify], a[href="#notify"], a[href^="#notify-"]');
      if (a) { e.preventDefault(); var d = document.querySelector('#Details-menu-drawer-container[open]'); if (d) { var hd = d.closest('header-drawer'), ds = d.querySelector('summary'); if (hd && hd.closeMenuDrawer) hd.closeMenuDrawer(null, ds); else d.removeAttribute('open'); if (ds) ds.setAttribute('aria-expanded', 'false'); }
        step(m, 'form'); open(m, a.getAttribute('data-notify') || (a.getAttribute('href') || '').replace('#notify-', '').replace('#notify', '') || 'Serenity'); return; }
      if (e.target.closest('[data-sc-notify] [data-sc-pop-close]')) close(m);
    });
    document.addEventListener('keydown', function (e) { var m = modal(); if (m && e.key === 'Escape' && !m.hidden) close(m); });
    document.addEventListener('DOMContentLoaded', function () {
      var m = modal(); if (!m) return;
      var f = m.querySelector('form'); if (f) { var a = f.getAttribute('action') || ''; if (a.indexOf('#') < 0) f.setAttribute('action', a + '#ScNotifyForm'); }
      if (m.querySelector('[data-sc-notify-error]')) { step(m, 'form'); open(m); }
      if (m.querySelector('[data-sc-notify-done]') || (/customer_posted=true/.test(location.search) && location.hash.indexOf('ScNotifyForm') > -1)) { step(m, 'done'); open(m); }
    });
  })();

  function init(scope) { scope = scope || document; initTabs(scope); initSliders(scope); initFilters(scope); initDialogs(scope); initRotate(scope); initCounts(scope); initPdp(scope); initReveal(scope); initSwitch(scope); initUgc(scope); initPop(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();

  /* ---- Theme editor: clicking a block in the sidebar shows it on the page ---- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-sc-pdp]').forEach(function (root) { if (root.scCleanup) root.scCleanup(); }); if (activeModal && e.target.contains(activeModal)) modalAccess(activeModal, false); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el.matches('[data-sc-tab]')) { activate(el.closest('[data-sc-tabs]'), el, false); }
    else if (el.classList.contains('sc-announce__msg')) { var bar = el.parentElement; bar.scPaused = true; bar.querySelectorAll('.sc-announce__msg').forEach(function (m) { m.classList.toggle('is-active', m === el); }); }
    else if (el.closest('[data-sc-track]')) { el.closest('[data-sc-track]').scrollTo({ left: el.offsetLeft - 24, behavior: 'smooth' }); }
    else if (el.tagName === 'DETAILS') { el.open = true; }
    if (el.hasAttribute('data-sc-in')) el.hidden = false;
  });
  document.addEventListener('shopify:block:deselect', function (e) { if (e.target.classList.contains('sc-announce__msg')) e.target.parentElement.scPaused = false; });
})();
